import React, { useState } from 'react';
import { Layout } from './components/layout/Layout';
import { ProgressStep } from './components/progress/ProgressStep';
import { MGAInformation } from './components/steps/MGAInformation';
import { UploadDocuments } from './components/steps/UploadDocuments';
import { UploadBordereau } from './components/steps/UploadBordereau';
import { RoleBasedDashboard } from './components/RoleBasedDashboard';
import { FinancialsHistory } from './components/steps/FinancialsHistory';
import { Product } from './components/steps/Product';
export function App() {
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedDashboard, setSelectedDashboard] = useState<string>('Executive Summary');
  const steps = [{
    id: 0,
    name: 'MGA Info',
    component: <MGAInformation data-id="element-0" />
  }, {
    id: 1,
    name: 'Financials/History',
    component: <FinancialsHistory data-id="element-1" />
  }, {
    id: 2,
    name: 'Product',
    component: <Product data-id="element-2" />
  }, {
    id: 3,
    name: 'Supporting Docs',
    component: <UploadDocuments data-id="element-3" />
  }, {
    id: 4,
    name: 'Bordereau',
    component: <UploadBordereau data-id="element-4" />
  }, {
    id: 5,
    name: 'Dashboard',
    component: <RoleBasedDashboard selectedDashboard={selectedDashboard} onNavigate={setSelectedDashboard} data-id="element-5" />
  }];
  const isDashboard = currentStep === 5;
  return <Layout currentStep={currentStep} setCurrentStep={setCurrentStep} steps={steps} selectedDashboard={selectedDashboard} setSelectedDashboard={setSelectedDashboard} data-id="element-6">
      {!isDashboard && <ProgressStep currentStep={currentStep} steps={steps} onChange={setCurrentStep} data-id="element-7" />}
      <div className={isDashboard ? '' : 'mt-6'} data-id="element-8">
        {steps[currentStep].component}
      </div>
    </Layout>;
}